<template>
  <div class="detail_main bg_detail is-scrollable has-background-white">
    <div class="detail_img_info">
      <a
        class="button has-text-white is-rounded diapo_button"
        @click="$parent.show = false">
        <span class="icon">
          <b-icon
            icon="chevron-left">
          </b-icon>
        </span>
        <label>Retour</label>
      </a>
      <img :src="url" class="imageBgOpp imgGoToTop">
    </div>
    <div class="leftVert topViolet rightVert bottomVert">
      <div class="tabs bottomVert">
        <ul class="p_size12 has-text-weight-bold">
          <li :class="{'underline is-active': active === 1}"
              @click="active = 1"
              class="is-paddingless">
            <a>Proposition</a>
          </li>
          <li :class="{'underline is-active': active === 2}"
              @click="active = 2"
              class="is-paddingless">
            <a>Caractéristiques</a>
          </li>
        </ul>
      </div>
      <div v-if="active === 1">
        <div class="columns is-mobile is-multiline is-marginless color-icon">
          <div
            v-if="detailFaceNumerique.extensionOpportunite.typeTarification &&
                  detailFaceNumerique.extensionOpportunite.quantite"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="timer"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Durée
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{formatDureeNum(detailFaceNumerique.extensionOpportunite.typeTarification,
                    detailFaceNumerique.extensionOpportunite.quantite)}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailFaceNumerique.extensionOpportunite.tarifHt"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="cash"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Tarif HT
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{tarifHt}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailFaceNumerique.extensionOpportunite.typeTarification &&
                  detailFaceNumerique.extensionOpportunite.quantite"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="cellphone-screenshot"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Mode de diffusion
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{modeDiff(detailFaceNumerique.extensionOpportunite.typeTarification)}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailFaceNumerique.extensionOpportunite.fraisAdserving"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="tooltip-plus"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Frais Adserving
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{fraisAdserving}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailFaceNumerique.extensionOpportunite.taxeMunicipale"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="ballot"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Taxes Municipales
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{taxeMunicipale}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailFaceNumerique.extensionOpportunite.spotsPub"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="camera-metering-spot"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Spot(s) Publicitaire(s)
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{detailFaceNumerique.extensionOpportunite.spotsPub}}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailFaceNumerique.extensionOpportunite.nbDiffusion"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="counter"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Diffusion/jour
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{detailFaceNumerique.extensionOpportunite.nbDiffusion}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="detailFaceNumerique.extensionOpportunite.commentaire">
          <p class=" p_size12 has-text-link has-text-weight-bold topViolet bottomViolet">
            Commentaire:
          </p>
          <div class="commentaire">
            <p class="has-text-link has-text-justify p_size11">
              {{detailFaceNumerique.extensionOpportunite.commentaire}}
            </p>
          </div>
        </div>
      </div>
      <div v-if="active === 2">
        <div class="columns is-mobile is-marginless is-multiline color-icon">
          <div class="column is-paddingless bottomViolet is-6">
            <div class="media">
              <b-icon
                icon="map-marker"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Adresse
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{adresse}}
                </p>
              </div>
            </div>
          </div>
          <div class="column is-paddingless bottomViolet is-6">
            <div class="media">
              <b-icon
                icon="vector-intersection"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Format
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{detailFaceNumerique.format}}
                </p>
              </div>
            </div>
          </div>
          <div class="column is-paddingless bottomViolet is-6">
            <div class="media">
              <b-icon
                icon="package-variant-closed"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Matériel
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{detailFaceNumerique.materiel}}
                </p>
              </div>
            </div>
          </div>
          <div v-if="detailFaceNumerique.extensionOpportunite.periode"
               class="column is-paddingless bottomViolet is-6 color-icon">
            <div class="media">
              <b-icon
                icon="timer"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Période
                </label><br>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{detailFaceNumerique.extensionOpportunite.periode}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!detailFaceNumerique.select" @click="contolSelect()"
         class="navbar is-fixed-bottom button is-primary boutonSelectM has-text-weight-bold">
      <p class="p_size11 centreM">Ajouter a ma sélection</p>
    </div>
    <div v-else @click="contolSelect()"
         class="navbar is-fixed-bottom button boutonRed boutonSelectM has-text-weight-bold">
      <p class="p_size11 centreM">Retirer de ma sélection</p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { iconColorGetter, TAILLE_ICON_GRAND } from '@/services/general/iconColorGetter';
import { formatNum, formatAdresse, urlPhoto, formatDureeNum, modeDiff } from '@/services/opportunite/formatTab';

export default {
  name: 'detailOpportunites',
  props: ['detailFaceNumerique'],
  data() {
    return {
      active: 1,
      select: true,
    };
  },
  computed: {
    tarifHt() {
      return formatNum(this.detailFaceNumerique.extensionOpportunite.tarifHt
      * this.detailFaceNumerique.extensionOpportunite.quantite);
    },
    fraisAdserving() {
      return formatNum(this.detailFaceNumerique.extensionOpportunite.fraisAdserving);
    },
    taxeMunicipale() {
      return formatNum(this.detailFaceNumerique.extensionOpportunite.taxeMunicipale);
    },
    adresse() {
      return formatAdresse(this.detailFaceNumerique);
    },
    url() {
      return urlPhoto(this.detailFaceNumerique.urlPhoto);
    },
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    contolSelect() {
      this.detailFaceNumerique.select = !this.detailFaceNumerique.select;
      if (this.detailFaceNumerique.select) {
        this.detailFaceNumerique.icon = iconColorGetter('#49db70', TAILLE_ICON_GRAND);
        this.add(this.detailFaceNumerique.extensionOpportunite.tarifHt
        * this.detailFaceNumerique.extensionOpportunite.quantite);
        this.addNbSelect();
      } else {
        this.detailFaceNumerique.icon = iconColorGetter('#009ce0', TAILLE_ICON_GRAND);
        this.substract(this.detailFaceNumerique.extensionOpportunite.tarifHt
        * this.detailFaceNumerique.extensionOpportunite.quantite);
        this.substractNbSelect();
      }
    },
    modeDiff(t) {
      return modeDiff(t);
    },
    formatDureeNum(t, q) {
      return formatDureeNum(t, q);
    },
  },
  mounted() {
    const test = document.querySelector('html');
    const test2 = document.querySelector('body');
    test.style.overflow = 'hidden';
    test2.style.overflow = 'hidden';
  },
  destroyed() {
    const test = document.querySelector('html');
    const test2 = document.querySelector('body');
    test.style.overflow = '';
    test2.style.overflow = '';
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/panneauxNumeriques/detailOpportunites.vue